module.exports = __webpack_public_path__ + "resource/usage.fdd05d20.svg";